export const PAYMENT_METHOD_RADIO_BUTTONS = 'payment-method-radio-buttons';
export const SWISH_NUMBER = 'swish_number';

export interface Step4FormValues {
  [PAYMENT_METHOD_RADIO_BUTTONS]: string;
  [SWISH_NUMBER]?: string;
}
